export function renderToimenpideEhdotukset({ data, content }) {
  const items = Array.isArray(data?.items) ? data.items : [];

  // ❌ If no items → do nothing
  if (items.length === 0) return;

  // Immediate items
  const immediate = items.filter(i => i.immediate);

  // Everything else that is not immediate
  const significant = items.filter(i => !i.immediate);

  const fixChars = (str) => (str || "").replace(/⁰/g, "°");

  const renderItemList = (items) => {
    for (const i of items) {
      content.push({ text: "• " + fixChars(i.text || "Ei toimenpiteitä."), style: "list" });
    }
  };

  // --- Normal cases ---
  if (significant.length > 0) {
    content.push({
      text: "Toimenpide-ehdotukset:",
      bold: true,
      style: "toimenpideHeading",
    });

    renderItemList(significant);
  }

  if (immediate.length > 0) {
    content.push({
      text: "Välittömästi korjattavat puutteet:",
      bold: true,
      style: "toimenpideHeading",
    });

    renderItemList(immediate);
  }
}